<template>
  <div
    class="bg-static-success-low text-static-default-hi rounded-md body-2 px-12 py-8"
  >
    <div class="flex items-center gap-8">
      <IconBoltFilled />
      <FormattedMessage :definition="translations.title" tag="p">
        <template #flashOffer>
          <span class="body-2-bold">
            {{ i18n(translations.flashOfferLabel) }}
          </span>
        </template>
        <template #previousBenefit>
          <span class="text-static-default-low body-2-striked">
            <slot name="previous" />
          </span>
        </template>
        <template #newBenefit>
          <span class="body-2">
            <slot name="new" />
          </span>
        </template>
      </FormattedMessage>
    </div>

    <div class="flex items-center gap-8">
      <div class="w-24" />
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconBoltFilled } from '@ds/icons/IconBoltFilled'

import translations from './FlashOffer.translations'

const i18n = useI18n()
</script>
